import { APPROVED_STATUS, WorldCountry, CodeService } from '../../shared';
import { Product } from '..';
import { BaseDto } from '../../core';

export class BestSeller extends BaseDto<BestSeller> {
  constructor(partial: Partial<BestSeller>) {
    super(partial);
  }
  id: number;
  displayCategoryCode: string;
  countryCode: string;
  approvedStatus: APPROVED_STATUS;
  created: Date;
  products?: Product[];

  country?: WorldCountry;

  setProductCountry(countryCode: string) {
    this.country = CodeService.getCountryCode(countryCode);
    return this.country;
  }
}
